export default Object.freeze({
  NOT_FOUND_IN_STOCK: 1,
});
